import Select from 'react-select';
import CustomButton from '../buttons/CustomButton';
import { reactSelectStyles } from '../../assets/js/react-select-styles';
import { useGetAllCustomersQuery } from '@states/customer/customer.api';
import { TSuccessResponse } from '@type-defs/general/TSuccessResponse';
import { TCustomer } from '@type-defs/customer/TCustomer';
import { useGetAllProductCategoriesQuery } from '@states/product/product-category.api';
import {useGetAllProductsQuery} from '@states/product/product.api';


const ProductFilter = (props: {
    filterRef: React.MutableRefObject<{
        product_category_id: undefined;
    }>;
    refetch: () => void;
}) => {
    const { filterRef, refetch } = props;

    const { data: customerData } = useGetAllCustomersQuery({});

    const customerRespose = customerData as any as TSuccessResponse<TCustomer>;

    const formattedData = customerRespose?.data?.map((c) => ({
        label: `${c.customer_first_name} ${c.customer_last_name || ''}`,
        value: c.customer_id,
    }));
    const {data: categoryDataResponse} =  useGetAllProductCategoriesQuery({limit : 1000})
    const {data : productDataResponse,
    isFetching,
    error: getAllError,
    } =  useGetAllProductsQuery({limit : 1000})
    //@ts-ignore
    const categoryData = categoryDataResponse?.data?.map((c) => ({
        label: `${c.product_category_name}`,
        value: c.product_category_id,
    }));
    //@ts-ignore
    const productData = productDataResponse?.data?.map((c) => ({
        label: `${c.product_name}`,
        value: c.product_id,
    }));



    const onChangeHandler = (val: any, key: string) => {
        const { value } = val;

        filterRef.current = {
            ...filterRef.current,
            [key]: value,
        };
    };

    return (
        <div className="flex items-end mb-5">
            <div className="mr-6 basis-[30%]">
                <label className="mb-2 text-gray-700" htmlFor="name">
                    Product Category Name
                </label>
                <Select
                    styles={reactSelectStyles}
                    placeholder="All"
                    options={
                        categoryData && [
                            { label: 'All', value: undefined },
                            ...categoryData,
                        ]
                    }
                    onChange={(val) => onChangeHandler(val, 'product_category_id')}
                />

            </div>

            <div className="mr-6 basis-[20%]">
                <label className="mb-2 text-gray-700" htmlFor="name">
                    Product Name
                </label>
                <Select
                    styles={reactSelectStyles}
                    placeholder="All"
                    options={
                        productData && [
                            { label: 'All', value: undefined },
                            ...productData,
                        ]
                    }
                    onChange={(val) => onChangeHandler(val, 'product_id')}
                />
            </div>
            <div className="basis-1/6">
                <CustomButton
                    handleClick={() => refetch()}
                    className="w-24 h-[2.4rem]"
                    title="Filter"
                />
            </div>
        </div>
    );
};

export default ProductFilter;
